import React from "react";
import { CustomFlowbiteTheme, Modal } from "flowbite-react";
import { BiSolidErrorAlt } from 'react-icons/bi'
import { useModal } from "../../../../hooks/ModalContext";
import { useBoleto } from "../../../../context/BoletoContext";
import { useContrato } from "../../../../context/ContratoContext";
import { useDividas } from "../../../../context/DividasContext";
import { IoIosWarning } from "react-icons/io";

interface ModalErroProps {
  message?: string;
  app?: string;
  setFormAba?: (value: React.SetStateAction<string>) => void
}

export const ModalErro = ({ message, app, setFormAba }: ModalErroProps) => {
  const { onClose, openErrorModal } = useModal()
  const { requestBoleto, emitirBoleto } = useBoleto()
  const { getContracts } = useContrato();
  const { selectedCredor, devedor } = useDividas();

  const themeModal: CustomFlowbiteTheme['modal'] = {
    root: {
      base: 'fixed top-0 right-0 left-0 z-40 h-modal h-screen overflow-y-auto overflow-x-hidden md:inset-0 md:h-full'
    }
  }
  function close() {
    if (openErrorModal.title !== 'Erro Emitir Boleto') {
      onClose(false, true)
    }
  }

  async function handelEmitirBoleto() {
    await emitirBoleto(requestBoleto)
    onClose(false, true)
  }

  async function closeModalBoleto() {
    if (setFormAba) {
      setFormAba('2ª via')
    }
    onClose(false, true)
    await getContracts({ cpf_cnpj: devedor?.cpf_cnpj, credor: selectedCredor.credor_crm, url: selectedCredor.url_ws, app: app ? app : 'ACIONA_WEB' })
  }
  return (
    <>
      <Modal
        // onClose={() => onClose(true)}
        show={openErrorModal.isOpen}
        // show={true}
        popup={true}
        size={"md"}
        onClick={() => close()}
        theme={themeModal}
      >
        <Modal.Body>
          {
            openErrorModal.title === 'Erro Emitir Boleto' ? (
              <div>
                <div className="flex items-center justify-center flex-col pt-6 px-0  ">
                  <IoIosWarning className="fill-amber-500 m-4" size={70} />
                  <p className="font-medium text-lg text-center m-2 text-gray-800 w-full">Erro ao enviar o acordo. Tentar novamente?</p>
                </div>
                <div className="w-full gap-4 items-center flex">
                  <button className="w-full text-white font-semibold bg-red-600 text-center p-2 rounded-md" onClick={() => closeModalBoleto()}>Não</button>
                  <button className="w-full text-white font-semibold bg-primary text-center p-2 rounded-md" onClick={() => handelEmitirBoleto()}>Sim</button>
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-center flex-col pt-6 px-0  ">
                <BiSolidErrorAlt className="fill-red-600 m-4" size={70} />
                <p className="font-medium text-lg text-center m-2 text-gray-800 w-full">{message ? message : openErrorModal.title}</p>
              </div>)
          }

        </Modal.Body>
      </Modal>
    </>
  )
}